import React, { useState, useEffect } from 'react';
import { Button } from 'react-bootstrap';
import axios from 'axios';
import { FaEye } from "react-icons/fa";
import { useNavigate, Link } from 'react-router-dom';
import jsPDF from 'jspdf';
import 'jspdf-autotable';

const StockManagement = () => {
    const token = localStorage.getItem('token');
    const Le_orderid = localStorage.getItem('Le_orderid');
    const navigate = useNavigate();

    const [companyDetails, setCompanyDetails] = useState({});
    const [vendorReprotList, setvendorreprotlist] = useState([]);
    
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState({
        id: null,
        customer_name: '',
        total_amount: 0,
        amount: 0,
        expenditure_amount: 0,
        OtherData: []
    });
    const [totalWorkDone, setTotalWorkDone] = useState(0);

    useEffect(() => {
        fetchVendor();
        fetchCompanyDetails();
    }, [token]);

    const fetchVendor = async () => {
        try {
            setLoading(true);
            const response = await axios.get(`${process.env.REACT_APP_API_URL}Site-ledger-list/${Le_orderid}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'x-access-token': token,
                },
            });

            const responseData = response.data.data || {};
            const filteredData = responseData.OtherData?.filter(
                item => item.order_id == Le_orderid
            ) || [];
        console.log("filteredData",filteredData);
            setData({
                id: responseData.id || null,
                customer_name: responseData.customer_name || '',
                total_amount: parseFloat(responseData.total_amount) || 0,
                amount: parseFloat(responseData.amount) || 0,
                expenditure_amount: parseFloat(responseData.expenditure_amount) || 0,
                OtherData: responseData.OtherData || []
            });

            // Calculate total work done
            const calculatedTotal = (responseData.OtherData || []).reduce((sum, item) => {
                const workDoneValue = item.work_done ? parseFloat(item.work_done) : 0;
                return sum + workDoneValue;
            }, 0);

            setTotalWorkDone(calculatedTotal);

        } catch (error) {
            console.error('Error fetching vendors:', error);
            setData({
                id: null,
                customer_name: '',
                total_amount: 0,
                amount: 0,
                expenditure_amount: 0,
                OtherData: []
            });
            setTotalWorkDone(0);
        } finally {
            setLoading(false);
        }
    };
    const fetchCompanyDetails = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}Company-details-list`, {
                headers: {
                    'Content-Type': 'application/json',
                    'x-access-token': token,
                },
            });
            if (response.data.status === 1 && response.data.data.length > 0) {
                setCompanyDetails(response.data.data[0]);
            }
        } catch (error) {
            console.error('Error fetching company details:', error);
        }
    };

    const handleView = (vendorId) => {
        // alert(vendorId);
        localStorage.setItem('ven_ledger_id', vendorId);
        navigate('/Vendor-Ledger-Customer-payment');
    };

    const handleViewCustomerpayment = () => {
        navigate('/Site-Ledger-Customer-payment');
    };

    const handleViewExpenditurepayment = () => {
        navigate('/Expenditure-Ledger-Customer-payment');
    };

    const handleViewLedger = (id) => {
        if (id) {
            localStorage.setItem('orderproduct_ladger_id', id);
            navigate('/Order-Product-View-Ladger');
        }
    };

    const downloadPDF = () => {
        const doc = new jsPDF();

        // Add company details
        doc.setFontSize(16);
        doc.text('Site Ledger Report', 14, 16);
        doc.setFontSize(12);
        doc.text(companyDetails.company_name || '', 14, 25);
        doc.text(`${companyDetails.company_address || ''}, ${companyDetails.state || ''}, ${companyDetails.city || ''} - ${companyDetails.pincode || ''}`, 14, 30);
        doc.text(`MOB NO.- ${companyDetails.mobile || ''}`, 14, 35);

        // Define table columns
        const tableColumn = ["Sr. No", "Name", "Vch Type", "Debit", "Credit", "Amount"];
        const tableRows = [];

        // Add customer rows
        tableRows.push([
            '',
            data.customer_name,
            "Sale",
            '',
            '',
            data.total_amount.toFixed(2)
        ]);

        tableRows.push([
            1,
            data.customer_name,
            "Receive",
            '',
            data.amount.toFixed(2),
            ''
        ]);

        tableRows.push([
            2,
            "Expenditure",
            "Payment",
            data.expenditure_amount.toFixed(2),
            '',
            ''
        ]);

        // Add vendor rows
        data.OtherData.forEach((vendor, index) => {
            tableRows.push([
                index + 3,
                vendor.vendor_name,
                "Payment",
                vendor.work_done ? parseFloat(vendor.work_done).toFixed(2) : '0.00',
                '',
                ''
            ]);
        });

        // Generate table
        doc.autoTable({
            head: [tableColumn],
            body: tableRows,
            startY: 45,
            styles: {
                fontSize: 10,
                cellPadding: 2
            },
            headStyles: {
                fillColor: [41, 128, 185],
                textColor: 255,
                fontStyle: 'bold'
            }
        });

        // Save the PDF
        doc.save('site_ledger_report.pdf');
    };

    const formatCurrency = (value) => {
        return new Intl.NumberFormat('en-IN', {
            maximumFractionDigits: 0
        }).format(parseFloat(value || 0));
    };

    const calculateDueAmount = (vendor) => {
        const workDone = parseFloat(vendor.work_done || 0);
        const paymentDone = parseFloat(vendor.work_done_payment || 0);
        return workDone - paymentDone;
    };

    if (loading) {
        return <div className="text-center mt-5">Loading...</div>;
    }

    return (
        <div className="App">
            <div className="card">
                <div className="card-header">
                    <div className="d-flex justify-content-between align-items-center">
                        <div className="w-50 mx-auto text-center">
                            <h6 className='fw-bold mb-0'>{companyDetails.company_name || ''}</h6>
                            <p className='addresslink mb-1'>
                                {companyDetails.company_address || ''}, {companyDetails.state || ''}, {companyDetails.city || ''} - {companyDetails.pincode || ''}
                            </p>
                            <span className='text-dark'>MOB NO.- {companyDetails.mobile || ''}</span>
                        </div>
                        <div className="d-flex gap-2">
                            <Button onClick={downloadPDF} variant="secondary">PDF</Button>
                            <Link to='/orderview' className='btn btn-primary'>Back</Link>
                        </div>
                    </div>
                </div>

                <div className="card-body">
                    <div className="table-responsive">
                        <table className='table table-striped table-hover border'>
                            <thead className='thead-dark'>
                                <tr className='mb-2' onClick={() => handleViewLedger(data.id)}>
                                    <td></td>
                                    <td className='fw-bold text-red'>{data.customer_name}</td>
                                    <td>Sale: {formatCurrency(data.total_amount)}</td>
                                    <td>Payment: {formatCurrency(data.expenditure_amount + totalWorkDone)}</td>
                                    <td>Closing Balance: {formatCurrency(data.amount - data.total_amount)}</td>
                                    <td>
                                        <Button variant="secondary" onClick={() => handleViewLedger(data.id)}>
                                            <FaEye />
                                        </Button>
                                    </td>
                                </tr>
                                <tr>
                                    <th>Sr.no</th>
                                    <th>Name</th>
                                    <th>Type</th>
                                    <th>Total Work</th>
                                    <th>Work Done</th>
                                    <th>Paid Amount</th>
                                    <th>Due Amount</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr onClick={handleViewCustomerpayment}>
                                    {/* <td className='font-weight-bold'>1</td> */}
                                    <td></td>
                                    <td className='font-weight-bold'>{data.customer_name}</td>
                                    <td className='font-weight-bold'>Receive</td>
                                    <td></td>
                                    <td></td>
                                    <td className='text-success font-weight-bold'>
                                        {formatCurrency(data.amount)}
                                    </td>
                                    <td></td>
                                    <td>
                                        <Button variant="secondary" onClick={handleViewCustomerpayment}>
                                            <FaEye />
                                        </Button>
                                    </td>
                                </tr>

                                <tr onClick={handleViewExpenditurepayment}>
                                    {/* <td>2</td> */}
                                    <td></td>
                                    <td>Expenditure</td>
                                    <td>Payment</td>
                                    <td></td>
                                    {/* <td></td> */}
                                    <td>{formatCurrency(data.expenditure_amount)}</td>
                                    <td></td>
                                    <td></td>
                                    <td>
                                        <Button variant="secondary" onClick={handleViewExpenditurepayment}>
                                            <FaEye />
                                        </Button>
                                    </td>
                                </tr>
                                {/* 
                                {data.OtherData.map((vendor, index) => (
                                    // <tr key={vendor.id || index} onClick={() => handleView(vendor.id)}>
                                    <tr key={vendor.id || index}>
                                        <td>{index + 1}</td>
                                        <td>{vendor.vendor_name}</td>
                                        <td>{vendor.category_name}</td>
                                        <td>{formatCurrency(vendor.unit_price)}</td>
                                        <td>{formatCurrency(vendor.work_done)}</td>
                                        <td className='text-success'>{formatCurrency(vendor.work_done_payment)}</td>
                                        <td className={calculateDueAmount(vendor) > 0 ? 'text-danger' : ''}>
                                            {formatCurrency(calculateDueAmount(vendor))}
                                        </td>
                                    </tr>
                                ))} */}

                                {[...new Map(data.OtherData.map(item => [item.vendor_name, item])).values()].map((vendor, index) => (
                                    <tr key={vendor.id || index} onClick={() => handleView(vendor.id)}>
                                        <td>{index + 1}</td>
                                        <td>{vendor.vendor_name}</td>
                                        <td>{vendor.category_name}</td>
                                        <td>{formatCurrency(vendor.unit_price)}</td>
                                        <td>{formatCurrency(vendor.work_done)}</td>
                                        <td className='text-success'>{formatCurrency(vendor.work_done_payment)}</td>
                                        <td className={calculateDueAmount(vendor) > 0 ? 'text-danger' : ''}>
                                            {formatCurrency(calculateDueAmount(vendor))}
                                        </td>
                                        <td>
                                        <Button variant="secondary" onClick={() => handleView(vendor.id)}>
                                            <FaEye />
                                        </Button>
                                        </td>
                                    </tr>
                                ))}

                            </tbody>
                            <tfoot>
                                <tr style={{
                                    position: 'sticky',
                                    bottom: 0,
                                    zIndex: 3,
                                    backgroundColor: 'black',
                                    color: 'white',
                                }}>
                                    <td colSpan="4" style={{ textAlign: 'right', fontWeight: 'bold' }}> V Amount:</td>
                                    <td colSpan="3" style={{ fontWeight: 'bold' }}>
                                        {formatCurrency(totalWorkDone + data.expenditure_amount)}
                                    </td>
                                    <td></td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>

                    <div className="d-flex justify-content-end mt-3">
                        <div className="totoalamount p-3 border rounded bg-light">
                            <div className='text-start mb-2'><strong>Customer Balance:</strong></div>
                            <div><strong>Total Amount:</strong> {formatCurrency(data.total_amount)}</div>
                            <div><strong>Receive Amount:</strong> {formatCurrency(data.amount)}</div>
                            <div className={data.amount - data.total_amount < 0 ? 'text-danger' : ''}>
                                <strong>Due Amount:</strong> {formatCurrency(data.amount - data.total_amount)}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default StockManagement;